module.exports = __webpack_public_path__ + "img/manResource.4437ca16.png";